<script type="text/javascript">
export default {
  props: {
    object: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    usingHash: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: null
    }
  },
  computed: {
    usingPath() {
      return this.path != null
    }
  },
  data() {
    return {
      filters: {},
      loading: false,
      items: {}
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = {
      object: this.object,
      id: this.id,
      using_hash: this.using_hash
    }

    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      let uri = this.usingPath ? this.path : this.routeUri('hyperion.audit')

      this.$http.get(uri, {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>
<template>
  <a-card size="small" type="inner" title="Audit Trails">
    <a-skeleton :loading="loading" active>
      <a-timeline :reverse="true" pending="Waiting for event..">
        <a-timeline-item v-for="(item,index) in items.data" :key="`timeline-${index}`">[{{ item.created_at }}]
          {{ item.message }}
        </a-timeline-item>
      </a-timeline>
    </a-skeleton>
  </a-card>
</template>
